export default __webpack_public_path__ + "static/media/jms-meditape.1aa878b0.jpg";